import React from "react";
import { useSelector } from "types/store";
import styles from "./style.module.css";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
const SeeWhatWasSentUsage = ({ usage, className, style }) => {
    const linkColorDarkMode = useSelector((state) => chatGPTReducer.getLinkColorDarkMode(state));
    const hasInputCount = (usage?.input_token_count ?? -1) > 0;
    const hasOutputCount = (usage?.output_token_count ?? -1) > 0;
    const hasTotalCount = (usage?.token_count ?? -1) > 0;
    const hasEstimatedCost = (usage?.estimated_cost ?? -1) > 0;
    const hasExecutionTime = (usage?.execution_time ?? -1) > 0;
    return (React.createElement("div", { className: styles.usageData + " " + (className ? className : ""), style: {
            color: linkColorDarkMode ? "#EFECF6" : "#333333",
            ...style
        } },
        hasInputCount && (React.createElement("div", { className: styles.usageDataItem },
            React.createElement("span", null, `Input Tokens: `),
            React.createElement("span", { style: { fontWeight: "bold" } }, usage?.input_token_count))),
        hasOutputCount && (React.createElement("div", { className: styles.usageDataItem },
            React.createElement("span", null, `Output Tokens: `),
            React.createElement("span", { style: { fontWeight: "bold" } }, usage?.output_token_count))),
        hasTotalCount && (React.createElement("div", { className: styles.usageDataItem },
            React.createElement("span", null, `Total Tokens: `),
            React.createElement("span", { style: { fontWeight: "bold" } }, usage?.token_count)))));
};
export default SeeWhatWasSentUsage;
